function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-width:0.7px;stroke:#000;}");

var _ref3 = /*#__PURE__*/React.createElement("title", null, "  Color wheel");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m465.8 264.4-83.9 0 -177.8 0-84.1 0",
  className: "a"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m292.9 437.3 0-83.9 0-177.8 0-84.1",
  className: "a"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m415.2 386.7-59.3-59.3M230.1 201.6 170.7 142.2",
  className: "a"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m170.7 386.7 59.3-59.3 125.7-125.7 59.4-59.4",
  className: "a"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M452.7 330.6 375.1 298.5 210.9 230.5 133.2 198.3",
  className: "a"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M226.8 424.2 258.9 346.6 326.9 182.4 359.1 104.7",
  className: "a"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M359.1 424.2 327 346.6 259 182.4 226.8 104.7",
  className: "a"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m133.2 330.6 77.5-32.1 164.2-68 77.7-32.2",
  className: "a"
});

var SvgColorwheel = function SvgColorwheel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-119.7118 62.29805)matrix(0.5524249 1.333612 -1.333672 0.5524 560.4805 -348.9834)",
    style: {
      strokeWidth: 0.7,
      stroke: "#000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m133 199.2c-8 19.4-12 40.3-12.9 61.3-1.4 3.8 1.5 4.7 4.7 4 26.1 0 52.2 0 78.3 0 1.7-1.6 0.9-4.9 1.5-7.3 0.3-9 3.3-17.5 5.6-26-0.3-2.1-3.4-2-4.9-3-23.8-9.9-47.5-19.9-71.5-29.3l-0.5 0.2-0.3 0.1z",
    style: {
      fill: "#ff0060",
      strokeDashoffset: 200,
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.1 105.5c-8.6 2.9-16.6 7.5-24.3 12.2-11 7-21.6 15-30.5 24.5 2.5 3.8 6.7 6.8 9.8 10.3 16.1 16.1 32.2 32.3 48.3 48.4 2.5 0 4.3-3.3 6.5-4.6 6.6-5.8 14.3-9.8 21.9-13.8 1.4-1.6-1-3.7-1.2-5.5-9.8-23.8-19.5-47.6-29.6-71.1-0.2-0.3-0.6-0.4-0.9-0.4z",
    style: {
      fill: "#ff6000",
      strokeDashoffset: 200,
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.9 91.6c-20.5 0.8-41.1 4.6-60.1 12.5-3.1 1-0.3 4.2 0.3 6.1 10 23.7 19.3 47.8 30.1 71.2 1.7 1.1 4-1 5.9-1.2 8.7-3.1 17.9-4.1 27.1-4.8 1.7-2.2 0.3-6 0.7-8.9 0-24.7 0-49.4 0-74.1-0.4-1.5-2.8-0.5-4-0.8z",
    style: {
      fill: "#ffc000",
      strokeDashoffset: 200,
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.9 91.7c-0.5 14.2-0.1 28.5-0.2 42.7 0 13.4 0 26.8 0 40.1 1.8 1.8 5.4 0.8 7.8 1.4 8.7 0.9 17.4 2.8 25.5 6 2.1-0.5 1.9-3.7 3.1-5.3 10-23.6 19.7-47.4 29.5-71.1-0.5-2.1-3.7-2-5.3-3C334.3 95.3 313.9 92.1 293.6 91.5l-0.5 0.2-0.2 0.1z",
    style: {
      fill: "#deff00",
      strokeDashoffset: 200,
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.4 105.4c-5.4 10.8-9.6 22.3-14.4 33.4-5.9 14.2-11.8 28.5-17.7 42.7 0.8 2.2 4.2 2.4 6.1 3.8 8 4.2 15.4 9.6 22 15.7 2.8-0.4 4.5-4.1 6.8-5.8 17.5-17.5 34.9-34.9 52.4-52.4 0.1-2.4-3.5-3.8-4.9-5.7-14.7-13.3-31.4-24.4-49.7-31.9l-0.5 0.1-0.1 0z",
    style: {
      fill: "#7eff00",
      strokeDashoffset: 200,
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.4 142.8c-19.3 19.3-38.7 38.7-58 58-0.1 2.4 3 4 4.2 6 5.8 7.1 10.4 14.8 14.5 23 3.4 0 6.5-2.5 9.7-3.5 22.2-9.3 44.6-18.3 66.7-27.8 1-2.4-1.5-4.9-2.1-7.1-8.6-18-19.8-35.1-34.3-48.8-0.2-0.2-0.5 0.1-0.7 0.2z",
    style: {
      fill: "#1eff00",
      strokeDashoffset: 200,
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.1 199.1c-24.6 9.4-48.8 19.6-73.1 29.7-1.4 0.6-3.8 1.2-3 3.2 3 9.9 5.5 19.9 5.7 30.2-0.3 3.9 5.1 1.5 7.4 2.2 25.3 0 50.5 0 75.8 0 1.9-1.9 0.1-5.8 0.5-8.4-0.8-19.4-5-38.7-12.5-56.6-0.3 0-0.5-0.4-0.8-0.3z",
    style: {
      fill: "#00ff42",
      strokeDashoffset: 200,
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382 264.6c-0.6 10.1-1.9 20.1-5.4 29.8-0.4 1.7-2.2 4.7 0.8 5 24.8 10.2 49.5 20.8 74.5 30.6 2.3-1.3 2.4-4.7 3.5-6.8 6.5-18.6 10.5-38.3 10.2-58.1-1.9-1.9-5.7-0.3-8.4-0.8-24.9 0-49.7 0-74.6 0l-0.5 0.2-0.2 0.1z",
    style: {
      fill: "#00ffa2",
      strokeDashoffset: 200,
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.9 298.9c-3 2.6-3.9 7-6.2 10.2-3.7 6.6-8.9 12.3-13.4 18.3 4.7 5.7 10.7 10.8 15.9 16.3 14.1 14.1 28.2 28.2 42.2 42.3 2.5 0.1 3.9-3.7 6-5.1 13.3-14.6 24.3-31.5 31.8-49.8-1.6-2.2-5.3-2.4-7.7-3.9-22.8-9.5-45.6-18.9-68.4-28.3l-0.3 0z",
    style: {
      fill: "#00fcff",
      strokeDashoffset: 200,
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.5 327.8c-8.3 7.7-17.6 14-27.9 18.6-0.8 2.5 1.9 5.4 2.5 8 9.7 22.9 18.6 46.1 29 68.6 1.7 1.3 4-1.1 5.8-1.6 17.2-8.1 33.3-18.8 47.1-31.9 2.6-1.7 3.6-4.2 0.4-5.9-18.6-18.6-37.2-37.2-55.8-55.8-0.4 0-0.7-0.5-1.1 0z",
    style: {
      fill: "#00a2ff",
      strokeDashoffset: 200,
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.4 347.2c-7.5 1.8-14.7 4.7-22.5 5.3-3.7 0.6-7.5 0.5-11.1 1-0.4 18.2-0.1 36.5-0.2 54.8 0.1 9.5-0.3 19.1 0.2 28.5 4.8 0.8 10.2 0.1 15.2-0.3 16.9-1.7 33.7-5.6 49.5-11.9 1.4-1.8-0.8-4.2-1.1-6-9.4-23.8-19.4-47.3-29.3-70.9-0.2-0.3-0.5-0.5-0.9-0.5z",
    style: {
      fill: "#0042ff",
      strokeDashoffset: 200,
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.9 347c-10.8 25.2-21.1 50.7-31.7 76 0.1 2.2 3.5 2.2 5 3.2 19.1 7.1 39.4 10.9 59.8 11 1.9-1.9 0.3-5.7 0.8-8.4 0-24.8 0-49.7 0-74.5-2-1.8-5.7-0.8-8.4-1.5-8.5-0.7-16.8-2.9-24.8-5.9l-0.5 0.1-0.2 0z",
    style: {
      fill: "#1e00ff",
      strokeDashoffset: 200,
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.6 327.7c-19.5 19.5-38.9 38.9-58.4 58.4 0 2.6 4 3.9 5.5 6 14.4 13.2 31.1 23.9 49 31.4 2.2-0.8 2.3-4.1 3.6-5.9 10-23.2 19.5-46.5 29-69.9-0.8-2.8-4.7-3.2-6.8-4.8-7.6-4-14.7-9.1-20.8-15.2-0.4 0-0.8-0.5-1.1 0z",
    style: {
      fill: "#7e00ff",
      strokeDashoffset: 200,
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.2 298.9c-25.4 10.3-50.7 20.8-76 31.5-1.3 1.7 1.1 3.8 1.5 5.6 8.5 18.6 20.3 35.7 34.7 50.1 2.6-0.5 3.9-3.7 6.1-5.1 17.8-17.6 35.4-35.3 53.1-53 0.1-2.4-3-3.9-4.3-5.9-5.9-6.8-10.3-14.6-14.2-22.7-0.3-0.1-0.5-0.7-0.9-0.4z",
    style: {
      fill: "#de00ff",
      strokeDashoffset: 200,
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.1 264.6c0.3 21.6 4.2 43.4 12.3 63.5 0.3 1.7 1.9 2.4 3.3 1.3 24.7-10.1 49.5-20.2 74-30.7 1.3-2.2-1-4.9-1.3-7.1-3-8.7-3.4-18-4.7-27-7.5-0.7-15.5-0.1-23.3-0.3-19.9 0-39.7 0-59.6 0l-0.5 0.2-0.2 0.1z",
    style: {
      fill: "#ff00c0",
      strokeDashoffset: 200,
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.5 142.9c-15.7 15.2-27.7 33.9-36.5 53.8-1.2 2.5 2.9 2.7 4.3 3.7 23.8 10 47.7 19.9 71.6 29.7 2.2-0.5 2.4-3.7 3.6-5.3 4-8.4 9.9-15.8 16-22.8-0.4-2.8-4.1-4.5-5.8-6.8-17.4-17.4-34.8-34.8-52.2-52.2-0.4 0-0.7-0.5-1.1 0z",
    style: {
      fill: "#f00",
      strokeDashoffset: 200,
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.8 264.4a88.9 88.9 0 0 1-88.9 88.9 88.9 88.9 0 0 1-88.9-88.9 88.9 88.9 0 0 1 88.9-88.9 88.9 88.9 0 0 1 88.9 88.9zm83.8 0A172.7 172.7 0 0 1 292.9 437.2 172.7 172.7 0 0 1 120.2 264.4 172.7 172.7 0 0 1 292.9 91.7 172.7 172.7 0 0 1 465.7 264.4Z",
    style: {
      fill: "none",
      strokeDashoffset: 200,
      strokeLinejoin: "round",
      strokeWidth: 0.7,
      stroke: "#000"
    }
  }), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgColorwheel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Colorwheel.b9adfef8.svg";
export { ForwardRef as ReactComponent };